<template>
    <ContentLoading
        class="logout"
        info_text="logout.loading"
    />

</template>

<script setup>
  import SAPOMailConfig from "@/SAPOMailConfig";
  import ContentLoading from "@/vue/Elements/Content/ContentLoading.vue";

  document.location = SAPOMailConfig.server.security.logout;
</script>